import React, { useState } from 'react';
import Dialog from '@components/atoms/dialog/dialog';
import useAnalyticEvents from '@hooks/analytics/use-analytic-events';
import { datadogRum } from '@datadog/browser-rum-slim';
import BuyerFees, { BuyerFeesProps } from '../buyer-fees-content/buyer-fees';
import styles from './buyer-fees-modale.module.scss';

type BuyerFeesModalProps = {
  children: React.ReactNode;
  trackingContext: string;
  productId: string;
} & BuyerFeesProps;

const BuyerFeesModal: React.FC<BuyerFeesModalProps> = ({
  breakdown,
  isSeller,
  productLocation,
  buyerLocation,
  children,
  trackingContext,
  productId,
  hasPhysicalAuthentication,
}): React.JSX.Element => {
  const [openModal, setOpenModal] = useState(false);
  const { sendAnalyticEvent } = useAnalyticEvents('product');

  const checkPricingBreakdownContract = () => {
    if (
      breakdown &&
      // missing data
      (!breakdown.buyerFees?.amount.cents ||
        !breakdown.sellerPrice?.cents ||
        // wrong sum
        breakdown.buyerFees.amount.cents + breakdown.sellerPrice.cents !== breakdown.fullPrice.cents)
    ) {
      datadogRum.addError('cart::monetization::empty-buyer-fees', {
        productId: productId,
        pricingBreakdown: breakdown,
        from: trackingContext,
      });
    }
  };

  const onOpenModal = () => {
    checkPricingBreakdownContract();

    sendAnalyticEvent('monetization_show_buyer_fee', {
      label: isSeller ? 'seller_view' : 'buyer_view',
      property: trackingContext,
    });
    setOpenModal(true);
  };

  const onCloseModal = () => {
    sendAnalyticEvent('monetization_buyer_fee_pop_in_close', {
      label: isSeller ? 'seller_view' : 'buyer_view',
      property: trackingContext,
      value: (breakdown?.buyerFees?.percent?.value || 0) * 100,
    });
    setOpenModal(false);
  };

  return (
    <>
      <button
        type="button"
        onClick={onOpenModal}
      >
        {children}
      </button>
      <Dialog
        key="buyerFeesModale"
        isOpen={openModal}
        closeDialog={onCloseModal}
        hasCloseIcon
        customClass={styles.buyerFeesModaleWrapper}
        styles={{
          content: {
            maxWidth: '660px',
            width: '100%',
          },
        }}
      >
        <BuyerFees
          breakdown={breakdown}
          isSeller={isSeller}
          productLocation={productLocation}
          buyerLocation={buyerLocation}
          hasPhysicalAuthentication={hasPhysicalAuthentication}
        />
      </Dialog>
    </>
  );
};

export default BuyerFeesModal;
